/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'


/* ++++++++++ --------------- EXPORT : COMMENTING CONFIGURATION GENERAL SECTION MEDIA COMMENTS: STYLES --------------- ++++++++++ */
export default theme => ({
  mediacomments: {
    '& .mediacommentspreview': {
      alignItems: 'center',
      '& .commentbox': {
        display: 'flex',
        width: '100%',
        height: '100%',
        maxWidth: pxToEm(400),
        maxHeight: pxToEm(250),
        alignItems: 'flex-start',
        background: '#f7f8fb',
        borderRadius: pxToEm(8),
        border: '2px solid #5e74d6',
        padding: '16px',
        '& .commenttextarea': {
          width: '100%',
          paddingBottom: '24px',
          marginBottom: '8px',
          borderBottom:`3px solid #5e74d6`,
          '& p': {
            marginBottom: pxToEm(16)
          }
        }
      },
      '& img': {
        borderRadius: pxToEm(8)
      },
      '& .commentrichmedia': {
        '& *[fill]:not(svg)': {
          fill: '#5866a5'
        }
      },
      '& .button': {
        padding: pxToEm(8),
        borderRadius: pxToEm(4),
        fontWeight: 600,
        fontSize: '16px',
        minHeight: '32px',
        maxHeight: '32px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#FFF', 
        color: '#061240',
        border: '2px solid #061240'
      },
      '& .postbutton': {
        background: '#061240', 
        color: '#FFF',
        padding: '6px 10px',
        width: '60px'
      }
    }
  }
});
